import Hobbie from './Hobbie';
import './Hobbies.css';

const Hobbies = (props) => {
  const icons = [
    {
      name: 'Lectura',
      icon: 'book.png',
    },
    {
      name: 'Peliculas',
      icon: 'clapperboard.png',
    },
    {
      name: 'Videojuegos',
      icon: 'consola.png',
    },
    {
      name: 'Deportes',
      icon: 'football.png',
    },
    {
      name: 'Entrenamiento',
      icon: 'gym.png',
    },
    {
      name: 'Musica',
      icon: 'music.png',
    },
  ];

  return (
    <div className={`about-hobbies ${props.style}`}>
      <p>Hobbies</p>

      <div className="about-hobbies-container">
        {icons.map((icon, key) => (
          <Hobbie name={icon.name} icon={icon.icon} key={key} />
        ))}
      </div>
    </div>
  );
};

export default Hobbies;
